<template>
  <div class="xl:max-w-[650px]">
    <!-- <p class="mb-7 text-base leading-7 text-black">{{ $t('giftogram.text-top') }}</p> -->
    <Input
      v-model="modelGiftogram.title"
      :label="t('giftogram.name-of-recipient')"
      :v$="v$?.title"
      style-input="border !border-blue-dark focus:border-blue-dark shadow-[0_12px_33px_0_rgba(5, 58, 65, 0.04)] w-full"
      class="mb-7"
      style-error="!relative"
      required
    />
    <Textarea
      v-model="modelGiftogram.message"
      :label="t('giftogram.greeting')"
      :v$="v$?.message"
      style-input="border !border-blue-dark focus:border-blue-dark shadow-[0_12px_33px_0_rgba(5, 58, 65, 0.04)] w-full"
      class="mb-3"
      style-error="!relative"
      required
    />
    <p v-if="showNumCharacters && maxCharacters" class="-mt-2 mb-2 text-end text-xs">
      {{ `${numCharacters}/${maxCharacters}` }}
    </p>
    <p class="text-lg leading-6 text-black">{{ $t('giftogram.text-bottom') }}</p>

    <Button
      :title="t('button.next')"
      :arrow-right="true"
      color="pink"
      class="my-8 w-full md:mb-12 lg:mb-8 lg:mt-12 lg:w-[315px]"
      @click="handleClickNext"
    />
  </div>
</template>

<script setup lang="ts">
import { Input, Button, Textarea } from 'refresh-ui'
import { useVModel } from '@vueuse/core'
import type { Validation } from '@vuelidate/core'

import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const { t } = useI18n()
const props = defineProps<{
  giftogram: any
  v$: Validation
  showNumCharacters?: boolean
  maxCharacters?: number
}>()

const emits = defineEmits(['update:giftogram', 'onNext'])
const modelGiftogram = useVModel(props, 'giftogram', emits)

const numCharacters = computed(() => modelGiftogram.value.message.length || 0)

const handleClickNext = () => {
  if (props.v$) {
    props.v$.$touch()
    props.v$.$validate()
    if (!props.v$.$invalid) emits('onNext')
    return
  }
  emits('onNext')
}
</script>
